import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

const target = document.getElementById('stockist-locator-widget');
const product = target?.getAttribute('data-product');
const brand = target?.getAttribute('data-brand');
const basic = target?.getAttribute('data-basic');
const layout = target?.getAttribute('data-layout');
// Only render if target is there
if (target) {
    ReactDOM.render(<App brand={brand} product={product} basic={basic && basic === 'true'} layout={layout} />, target);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
